"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Mar 12 2020
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var ForecastSimulationConflictNodeDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationConflictNodeDTO, _DomainObject_1$Domai);

  /**
   * @param {string} id
   * @param {string} externalId
   * @param {string} name
   */
  function ForecastSimulationConflictNodeDTO(id, externalId, name) {
    var _this;

    _classCallCheck(this, ForecastSimulationConflictNodeDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictNodeDTO).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    return _this;
  }

  return ForecastSimulationConflictNodeDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationConflictNodeDTO = ForecastSimulationConflictNodeDTO;